<form  nz-form style="padding-top:12px;padding-right:12px" [formGroup]="validateForm" autocomplete="off" #form>
  <div nz-row [nzGutter]="['0','0']">
    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="id">Chọn nhãn</nz-form-label>
        <nz-form-control nzSpan="24">
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn nhãn" formControlName="id" [nzCustomTemplate]="templateSelect">
            <nz-option *ngFor="let tag of tags" [nzLabel]="tag.name" [nzValue]="tag.id"></nz-option>
          </nz-select>
          <ng-template #templateSelect let-selected>
            <nz-tag [nzColor]="colorSelected">
              <i nz-icon nzType="tag" nzTheme="outline"></i>
              {{ selected.nzLabel }}
            </nz-tag>
          </ng-template>
      </nz-form-control>
      </nz-form-item >
    </div>
  </div>
  <div *nzModalFooter>
    <button nz-button (click)="close()">Đóng</button>
    <button nz-button (click)="add()" [nzSize]="'large'" nzType="primary">
      Cài đặt
    </button>
  </div>
</form>